import { useState } from "react";
import {
    Button,
    TabPanel,
    Tab,
    Tabs,
    TabsHeader,
    TabsBody,
    Card,
    Typography,
    Select,
    Option,
} from "@material-tailwind/react";
import { GobbyTable, GobbyTableHead, GobbyTableBody, GobbyTableRow, GobbyTableHeader, GobbyTableCell } from "components/ui/gobby-table";
import InfoDialog from "components/dialog/info-dialog";
import YouTubeEmbed from "utils/YouTubeEmbed";

export default function ModerationTab({
    tabValue,
    surveyAbuse,
    setShowProcessDialog,
    setProcessingReport,
    surveyAbuseError,
    moderationFilter,
    setModerationFilter,
    surveyRespondentAnswers,
    surveyRespondentAnswersError,
    modQShown,
    setModQShown,
    setConfirmingAnswer,
    setShowConfirmReportDialog,
}) {
    // Collapse Controls
    const [collapseModerationInfo, setCollapseModerationInfo] = useState(false);

    return (
        <>
            {/* Outer TabPanel (parent decides when to render) */}
            <TabPanel value={tabValue}>
                {!!surveyAbuse && (
                    <Card className="card" shadow={false}>
                        <div className="flex justify-end mb-2">
                            <InfoDialog title="Moderating responses">
                                <div className="text-black">
                                    <YouTubeEmbed
                                        videoId="64kE6LVgJhI"
                                        title="Moderating responses"
                                    />
                                </div>
                            </InfoDialog>
                        </div>
                        {/* Inner Tabs for moderation filter */}
                        <Tabs
                            value={moderationFilter}
                            onChange={(val) => setModerationFilter(val)}
                        >
                            <TabsHeader className="card-inner flex justify-end mb-2 sm:mb-4">
                                <Tab value="reports" className="tab">
                                    Reported Responses
                                </Tab>
                                <Tab
                                    value="respondent_answers"
                                    className="tab ml-4"
                                >
                                    All Responses
                                </Tab>
                            </TabsHeader>

                            <TabsBody>
                                {/* Reports Panel */}
                                <TabPanel value="reports" className="p-0">
                                    <div className="card-inner !bg-transparent">
                                        <GobbyTable>
                                            <GobbyTableHead>
                                                <GobbyTableRow className="card-inner-header">
                                                    <GobbyTableHeader className="w-2/6 py-2">
                                                        Reported Response
                                                    </GobbyTableHeader>
                                                    <GobbyTableHeader className="w-1/12 sm:px-6 text-center">
                                                        Status
                                                    </GobbyTableHeader>
                                                    <GobbyTableHeader className="w-2/6">
                                                        User Comment(s)
                                                    </GobbyTableHeader>
                                                    <GobbyTableHeader className="w-2/6">
                                                        Admin Comment(s)
                                                    </GobbyTableHeader>
                                                    <GobbyTableHeader className="w-1/12">
                                                        &nbsp;
                                                    </GobbyTableHeader>
                                                </GobbyTableRow>
                                            </GobbyTableHead>
                                            <GobbyTableBody>
                                                {surveyAbuse.abuse_reports.map(
                                                    (report) => (
                                                        <GobbyTableRow
                                                            key={report.id}
                                                        >
                                                            {/* Reported Response */}
                                                            <GobbyTableCell className="pl-2">
                                                                {
                                                                    report.answer_text
                                                                }
                                                            </GobbyTableCell>

                                                            {/* Status */}
                                                            <GobbyTableCell className="text-center">
                                                                {report.status}
                                                            </GobbyTableCell>

                                                            {/* User Comment */}
                                                            <GobbyTableCell className="px-2">
                                                                {report.user_comment ||
                                                                    "N/A"}
                                                            </GobbyTableCell>

                                                            {/* Admin Comment */}
                                                            <GobbyTableCell className="px-2">
                                                                {report.admin_comment ||
                                                                    "N/A"}
                                                            </GobbyTableCell>

                                                            {/* Actions */}
                                                            <GobbyTableCell className="text-right md:pr-2">
                                                                <Button
                                                                    type="button"
                                                                    className="btn btn--primary"
                                                                    onClick={() => {
                                                                        setProcessingReport(
                                                                            report,
                                                                        );
                                                                        setShowProcessDialog(
                                                                            true,
                                                                        );
                                                                    }}
                                                                >
                                                                    Edit
                                                                </Button>
                                                            </GobbyTableCell>
                                                        </GobbyTableRow>
                                                    ),
                                                )}
                                            </GobbyTableBody>
                                        </GobbyTable>
                                    </div>
                                </TabPanel>

                                {/* Respondent Answers Panel */}
                                <TabPanel value="respondent_answers" className="p-0 pt-2">
                                    <div className="w-full mb-4">
                                        <Select
                                            label="Select a question to moderate"
                                            value={modQShown?.toString() || ""}
                                            onChange={(e) => {
                                                const indexInt = parseInt(
                                                    e,
                                                    10,
                                                );
                                                setModQShown(indexInt);
                                            }}
                                            menuProps={{
                                                className: "max-h-[200px] overflow-y-auto",
                                            }}
                                        >
                                            {surveyRespondentAnswers?.length ? (
                                                surveyRespondentAnswers
                                                    .map((q, originalIndex) => ({ ...q, originalIndex }))
                                                    .filter(
                                                        (q) =>
                                                            q.question_type ===
                                                                "freeform" ||
                                                            q.question_type ===
                                                                "mixed",
                                                    )
                                                    .map(
                                                        (q) => (
                                                            <Option
                                                                key={q.id}
                                                                value={`${q.originalIndex}`}
                                                            >
                                                                Question{" "}
                                                                {q.position}:{" "}
                                                                {q.text}
                                                            </Option>
                                                        ),
                                                    )
                                            ) : (
                                                <Option disabled>
                                                    No questions available
                                                </Option>
                                            )}
                                        </Select>
                                    </div>

                                    <div className="card-inner !bg-transparent">
                                        <div className="rounded-lg w-full overflow-x-auto">
                                            <GobbyTable>
                                                <GobbyTableHead>
                                                    <GobbyTableRow>
                                                        <GobbyTableHeader className="pt-4 w-5/6 pl-2">
                                                            Response Text
                                                        </GobbyTableHeader>
                                                        <GobbyTableHeader className="pt-4 w-1/12 text-center">
                                                            Hidden
                                                        </GobbyTableHeader>
                                                        <GobbyTableHeader className="w-1/12">
                                                            &nbsp;
                                                        </GobbyTableHeader>
                                                    </GobbyTableRow>
                                                </GobbyTableHead>
                                                <GobbyTableBody>
                                                    {surveyRespondentAnswers?.[
                                                        modQShown
                                                    ]?.respondent_answers.map(
                                                        (answer) => (
                                                            <GobbyTableRow
                                                                key={answer.id}
                                                            >
                                                                <GobbyTableCell className="pl-2">
                                                                    {
                                                                        answer.text
                                                                    }
                                                                </GobbyTableCell>
                                                                <GobbyTableCell className="text-center">
                                                                    {answer.hidden
                                                                        ? "Yes"
                                                                        : "No"}
                                                                </GobbyTableCell>
                                                                <GobbyTableCell className="text-right md:pr-2 py-1">
                                                                    <Button
                                                                        type="button"
                                                                        className="btn btn--danger"
                                                                        onClick={() => {
                                                                            setConfirmingAnswer(
                                                                                answer,
                                                                            );
                                                                            setShowConfirmReportDialog(
                                                                                true,
                                                                            );
                                                                        }}
                                                                    >
                                                                        Report
                                                                    </Button>
                                                                </GobbyTableCell>
                                                            </GobbyTableRow>
                                                        ),
                                                    )}
                                                </GobbyTableBody>
                                            </GobbyTable>
                                        </div>
                                    </div>
                                </TabPanel>
                            </TabsBody>
                        </Tabs>
                    </Card>
                )}

                {!!surveyAbuseError && (
                    <Typography>Error loading survey abuse reports</Typography>
                )}
            </TabPanel>
        </>
    );
}
